module.exports = __webpack_public_path__ + "static/media/Procontrol_1-min.8aa87280.jpg";